export default (attr = [], id) => attr.find((attr) => attr?.identifier === id)?.values[0]?.identifier;
